@if (showTitle) {
    <div class="detail-title">
        <h1>
            @if (auditName) {
                <span>
                    {{ auditName }}
                </span>
            }
        </h1>
    </div>
}

<pcg-table
    #table
    [ajaxData]="filters"
    [pcgSort]="[['dateChanged', 'desc']]"
    dataSource="api/AuditHistory/GetAuditHistory"
    [columnDefs]="columns"
    (tableReceive)="auditName = $event.value"
    [canExportTableToExcel]="true"
>
    <ng-container matColumnDef="friendlyRecordId">
        <th mat-header-cell [pcg-sort-header]="'friendlyRecordId'" *matHeaderCellDef>{{ columns.get('friendlyRecordId').displayName }}</th>
        <td mat-cell *matCellDef="let row">{{ row.friendlyRecordId }}</td>
    </ng-container>

    <ng-container matColumnDef="dateChanged">
        <th mat-header-cell [pcg-sort-header]="'dateChanged'" *matHeaderCellDef>{{ columns.get('dateChanged').displayName }}</th>
        <td mat-cell *matCellDef="let row">{{ row.dateChangedFormatted }}</td>
    </ng-container>

    <ng-container matColumnDef="field">
        <th mat-header-cell [pcg-sort-header]="'field'" *matHeaderCellDef>{{ columns.get('field').displayName }}</th>
        <td mat-cell *matCellDef="let row">{{ row.field }}</td>
    </ng-container>

    <ng-container matColumnDef="changedFrom">
        <th mat-header-cell [pcg-sort-header]="'changedFrom'" *matHeaderCellDef>{{ columns.get('changedFrom').displayName }}</th>
        <td mat-cell *matCellDef="let row">{{ row.changedFrom }}</td>
    </ng-container>

    <ng-container matColumnDef="changedTo">
        <th mat-header-cell [pcg-sort-header]="'changedTo'" *matHeaderCellDef>{{ columns.get('changedTo').displayName }}</th>
        <td mat-cell *matCellDef="let row">{{ row.changedTo }}</td>
    </ng-container>

    <ng-container matColumnDef="changedBy">
        <th mat-header-cell [pcg-sort-header]="'changedBy'" *matHeaderCellDef>{{ columns.get('changedBy').displayName }}</th>
        <td mat-cell *matCellDef="let row">{{ row.changedBy }}</td>
    </ng-container>
</pcg-table>
